export function create_empty_step(order = 1) {
  return {
    entity_type_id: '',
    order,
    expected_signer_count: 1,
  };
}

export function create_esigning_workflows_data() {
  return {
    workflow_form: {
      name: '',
      description: '',
    },
    workflows: [],
    workflow_steps: [create_empty_step()],
    entity_types: [],
    entity_types_loading: false,
    workflows_loading: false,
    workflow_running: false,
  };
}

export function normalize_workflow_step(step) {
  if (!step || typeof step !== 'object') {
    return null;
  }

  const entity_type_name = String(step.entity_type_name || '').trim();
  const expected_signer_count = Number(step.expected_signer_count || 0) || 0;

  return {
    id: step.id || null,
    order: Number(step.order || 0) || 0,
    entity_type_id: Number(step.entity_type_id || 0) || null,
    entity_type_name,
    expected_signer_count,
  };
}

export function normalize_workflow(workflow) {
  if (!workflow || typeof workflow !== 'object' || !workflow.id) {
    return null;
  }

  const steps = (Array.isArray(workflow.steps) ? workflow.steps : [])
    .map(normalize_workflow_step)
    .filter(Boolean);

  return {
    id: Number(workflow.id),
    name: String(workflow.name || '').trim() || 'Untitled Workflow',
    description: String(workflow.description || '').trim(),
    created_at: workflow.created_at || null,
    steps,
    step_count: Number(workflow.step_count || steps.length || 0) || 0,
    total_expected_signers: Number(workflow.total_expected_signers || 0) || 0,
    assigned_templates: Array.isArray(workflow.assigned_templates) ? workflow.assigned_templates : [],
    assigned_template_count: Number(
      workflow.assigned_template_count ||
      (Array.isArray(workflow.assigned_templates) ? workflow.assigned_templates.length : 0) ||
      0,
    ) || 0,
    is_assigned: Boolean(workflow.is_assigned),
  };
}

const esigning_workflows_computed = {
  has_workflows() {
    return this.workflows.length > 0;
  },

  entity_type_options() {
    const fetched_options = (Array.isArray(this.entity_types) ? this.entity_types : [])
      .map((entity_type, index) => this.map_entity_type_option(entity_type, index))
      .filter(Boolean);

    const selected_query_option = this.get_selected_query_entity_type_option();

    if (!selected_query_option) {
      return fetched_options;
    }

    const has_selected_option = fetched_options.some(
      (option) => String(option.value) === String(selected_query_option.value),
    );

    return has_selected_option
      ? fetched_options
      : [selected_query_option, ...fetched_options];
  },
};

export default esigning_workflows_computed;
